import { BudgetFilterKeys, RangeType } from '../constants';
import {
  ErrorText,
  Header,
  InputErrorWrapper,
  MiniGreyBar
} from '../ExperimentBudget.styles';
import { useBudgetPanelErrors } from '../hooks';
import { useUpdatePriceFilters, useValidatePriceInput } from '../hooks/Price';
import RangeInput from '../RangeInput';
import useRangeInput from '../RangeInput/useRangeInput';

type Options = {
  length: number;
  step: number;
  base: number;
};

const generateOptions = ({ length, step, base }: Options) =>
  Array.from({ length }, (_, i) => base + i * step);

const optionsMap = {
  max: {
    length: 7,
    step: 10000,
    base: 40000
  },
  min: {
    length: 6,
    step: 5000,
    base: 5000
  }
};

const filterKey = BudgetFilterKeys.Price;

export default function Price() {
  const { values, updateValues } = useRangeInput(filterKey);
  const updatePriceFilters = useUpdatePriceFilters(values);
  const validateInput = useValidatePriceInput(values);
  const { errors, updateErrors } = useBudgetPanelErrors();

  return (
    <div className="flex flex-col gap-16 justify-between w-full m:flex-row m:items-center l:flex-col l:items-start">
      <Header className="self-start m:pt-[18px] l:pt-0">
        Shop by Price Range
      </Header>
      <div className="flex gap-8 w-full m:max-w-[352px] l:flex-col l:gap-0 l:max-w-full">
        <InputErrorWrapper className="w-[175.1px] m:max-w-[160px] m:w-full l:max-w-full l:w-full">
          <RangeInput
            errors={errors}
            filterKey={filterKey}
            isValidInput={validateInput}
            rangeOptions={generateOptions(optionsMap[RangeType.Min])}
            rangeType={RangeType.Min}
            updateErrors={updateErrors}
            updateFilters={updatePriceFilters}
            updateValues={updateValues}
            value={values?.[RangeType.Min]?.toString() ?? ''}
          />
          <ErrorText className={errors?.[RangeType.Min] ? 'block' : 'hidden'}>
            {errors[RangeType.Min]}
          </ErrorText>
        </InputErrorWrapper>

        <div className="flex h-[52px] justify-between self-start l:flex l:h-16 l:items-center l:mx-0 l:my-8 l:pt-0 l:w-full">
          <MiniGreyBar />
          <p className="self-center t-label-s text-blue-6 l:mx-16">TO</p>
          <MiniGreyBar />
        </div>

        <InputErrorWrapper className="w-[175.1px] m:max-w-[160px] m:w-full l:max-w-full l:w-full">
          <RangeInput
            errors={errors}
            filterKey={filterKey}
            isValidInput={validateInput}
            rangeOptions={generateOptions(optionsMap[RangeType.Max])}
            rangeType={RangeType.Max}
            updateErrors={updateErrors}
            updateFilters={updatePriceFilters}
            updateValues={updateValues}
            value={values?.[RangeType.Max]?.toString() ?? ''}
          />
          <ErrorText className={errors?.[RangeType.Max] ? 'block' : 'hidden'}>
            {errors[RangeType.Max]}
          </ErrorText>
        </InputErrorWrapper>
      </div>
    </div>
  );
}
